export default __webpack_public_path__ + "static/media/warbishop_white.59df694b.svg";